"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Report = void 0;
/*
 * @Description: event report class
 * @Author: shijie.zou
 * @Version: entry-task-1.0.0
 * @Date: 2022-04-28 10:27:04
 */
var axios_1 = require("axios");
var constants_1 = require("./constants");
var proto_1 = require("../proto");
var Report = /** @class */ (function () {
    function Report(params) {
        var _a;
        this.reportNoLimit = false;
        this.reported = false;
        this.events = new proto_1.endpointevent.EventList();
        this._country = params.country;
        this._env = params.env;
        this._biz = params.biz;
        this._sdkVersion = params.sdkVersion;
        this._domain = (_a = constants_1.ICountryDomain[params.country]) !== null && _a !== void 0 ? _a : 'sg';
        if (this._domain === 'cn') {
            this._domain = 'sg';
        }
        this._serviceIndex = params.serviceIndex;
        this._serviceId = params.serviceId;
        this._vid = params.vid;
        this._uid = params.uid;
        this.reportNoLimit = params.reportNoLimit;
    }
    Report.prototype.genHeader = function (eventId) {
        return proto_1.endpointevent.Header.create({
            id: eventId,
            uid: this._uid,
            biz: 101,
            sceneId: 109,
            country: this._country,
            os: 2,
            ua: window.navigator.userAgent,
            sdkVersion: this._sdkVersion,
            timestamp: Date.now()
        });
    };
    Report.prototype.GetEndpointCfgEvent = function (params) {
        var body = proto_1.endpointevent.GetEndpointCfgEvent.create(params);
        var ev = proto_1.endpointevent.Event.create({
            header: this.genHeader(proto_1.endpointevent.EventID.MMSGetEndpointCfgEvent),
            body: proto_1.endpointevent.GetEndpointCfgEvent.encode(body).finish()
        });
        this.events.events.push(ev);
        return this;
    };
    Report.prototype.report = function () {
        var _a;
        if (this.reported && !this.reportNoLimit)
            return;
        else
            this.reported = true;
        var env = (_a = new Map([
            [constants_1.IEnv.TEST, 'test.'],
            [constants_1.IEnv.UAT, 'uat.'],
            [constants_1.IEnv.LIVE, ''],
            [constants_1.IEnv.STAGING, 'staging.'],
            [constants_1.IEnv.TEST_STABLE, 'staging.']
        ]).get(this._env)) !== null && _a !== void 0 ? _a : 'staging.';
        var url = "https://data-rep.livetech.".concat(env, "shopee.").concat(this._domain, "/dataapi/dataweb/event/reportPB");
        var data = proto_1.endpointevent.EventList.encode(this.events).finish();
        this.events.events.length = 0;
        return axios_1.default.post(url, data.slice(), {
            headers: {
                'Content-Type': 'application/octet-stream'
            }
        });
    };
    return Report;
}());
exports.Report = Report;
